/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import HowItWorksSectionBase from "@/src/components/Sections/Common/HowItWorksSection/HowItWorksSectionBase";
import PenIcon from "@/src/assets/icons/traffic/toggleable/IconWriting";
import IncomingCallIcon from "@/src/assets/icons/traffic/toggleable/IconIncomingCall";
import HandshakeIcon from "@/src/assets/icons/traffic/toggleable/IconShakeHands";
const HowItWorksSectionTrafficAccident = () => {
  return (
    <HowItWorksSectionBase
      sections={[
        {
          title: "1. Fall schildern",
          description: "Sie beschreiben kurz, was bei Ihrem Verkehrsunfall geschehen ist und laden Unterlagen dazu hoch.",
          icon: PenIcon,
        },
        {
          title: "2. Vorgehen besprechen",
          description: "Wir setzen uns mit dem KFZ-Haftpflichtversicherer Ihres Unfallgegners in Verbindung und stimmen mit Ihnen das weitere Vorgehen ab.",
          icon: IncomingCallIcon,
        },
        {
          title: "3. Einigung oder Urteil",
          description: "Wir setzen uns schnell und professionell für die Durchsetzung Ihrer Ansprüche ein.",
          icon: HandshakeIcon,
        },
      ]}
    />
  );
};

export default HowItWorksSectionTrafficAccident;
